import type { ComponentProps } from 'react';
import { OwcHeader } from '@one/react';

export type PocHeaderProps = ComponentProps<typeof OwcHeader>;

export const PocHeader: React.FC<PocHeaderProps> = (props) => <OwcHeader {...props} />;
